/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RSlugRouteImport } from './routes/r.$slug'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthScheduleRouteImport } from './routes/_auth.schedule'
import { Route as AuthResponderRouteImport } from './routes/_auth.responder'
import { Route as AuthOnboardingRouteImport } from './routes/_auth.onboarding'
import { Route as AuthMediaRouteImport } from './routes/_auth.media'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthClientsRouteImport } from './routes/_auth.clients'
import { Route as AuthAnalyzeRouteImport } from './routes/_auth.analyze'
import { Route as AuthAdminRouteImport } from './routes/_auth.admin'
import { Route as AuthMonitorIndexRouteImport } from './routes/_auth.monitor.index'
import { Route as AuthMediaIndexRouteImport } from './routes/_auth.media.index'
import { Route as AuthClientsIndexRouteImport } from './routes/_auth.clients.index'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth.admin.index'
import { Route as PublicReportsTokenRouteImport } from './routes/public.reports.$token'
import { Route as AuthMonitorProjectIdRouteImport } from './routes/_auth.monitor.$projectId'
import { Route as AuthMediaReportsRouteImport } from './routes/_auth.media.reports'
import { Route as AuthMediaOutletsRouteImport } from './routes/_auth.media.outlets'
import { Route as AuthMediaClientsRouteImport } from './routes/_auth.media.clients'
import { Route as AuthMediaCampaignsRouteImport } from './routes/_auth.media.campaigns'
import { Route as AuthMediaBudgetsRouteImport } from './routes/_auth.media.budgets'
import { Route as AuthMediaAdsRouteImport } from './routes/_auth.media.ads'
import { Route as AuthMediaAdTypesRouteImport } from './routes/_auth.media.ad-types'
import { Route as AuthMediaAdCategoriesRouteImport } from './routes/_auth.media.ad-categories'
import { Route as AuthClientsClientIdRouteImport } from './routes/_auth.clients.$clientId'
import { Route as AuthAdminUsersRouteImport } from './routes/_auth.admin.users'
import { Route as AuthAdminProjectsRouteImport } from './routes/_auth.admin.projects'
import { Route as AuthAdminOutletKindsRouteImport } from './routes/_auth.admin.outlet-kinds'
import { Route as AuthAdminLoginContentRouteImport } from './routes/_auth.admin.login-content'
import { Route as AuthAdminBrandingRouteImport } from './routes/_auth.admin.branding'
import { Route as AuthAdminBillingRouteImport } from './routes/_auth.admin.billing'
import { Route as AuthAdminAuditRouteImport } from './routes/_auth.admin.audit'
import { Route as AuthMonitorProjectIdSetupRouteImport } from './routes/_auth.monitor.$projectId_.setup'
import { Route as AuthMediaReportsReportIdRouteImport } from './routes/_auth.media.reports_.$reportId'
import { Route as AuthMediaPlacementsPlacementIdRouteImport } from './routes/_auth.media.placements_.$placementId'
import { Route as AuthMediaCampaignsNewRouteImport } from './routes/_auth.media.campaigns_.new'
import { Route as AuthMediaCampaignsCampaignIdRouteImport } from './routes/_auth.media.campaigns_.$campaignId'
import { Route as AuthMediaAdsAdIdRouteImport } from './routes/_auth.media.ads_.$adId'
import { Route as AuthAdminAccountsAccountIdRouteImport } from './routes/_auth.admin.accounts.$accountId'
import { Route as AuthMediaReportsRunsRunIdRouteImport } from './routes/_auth.media.reports_.runs.$runId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RSlugRoute = RSlugRouteImport.update({
  id: '/r/$slug',
  path: '/r/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScheduleRoute = AuthScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResponderRoute = AuthResponderRouteImport.update({
  id: '/responder',
  path: '/responder',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMediaRoute = AuthMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsRoute = AuthClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAnalyzeRoute = AuthAnalyzeRouteImport.update({
  id: '/analyze',
  path: '/analyze',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMonitorIndexRoute = AuthMonitorIndexRouteImport.update({
  id: '/monitor/',
  path: '/monitor/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMediaIndexRoute = AuthMediaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthClientsIndexRoute = AuthClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthClientsRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const PublicReportsTokenRoute = PublicReportsTokenRouteImport.update({
  id: '/public/reports/$token',
  path: '/public/reports/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMonitorProjectIdRoute = AuthMonitorProjectIdRouteImport.update({
  id: '/monitor/$projectId',
  path: '/monitor/$projectId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMediaReportsRoute = AuthMediaReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaOutletsRoute = AuthMediaOutletsRouteImport.update({
  id: '/outlets',
  path: '/outlets',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaClientsRoute = AuthMediaClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaCampaignsRoute = AuthMediaCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaBudgetsRoute = AuthMediaBudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaAdsRoute = AuthMediaAdsRouteImport.update({
  id: '/ads',
  path: '/ads',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaAdTypesRoute = AuthMediaAdTypesRouteImport.update({
  id: '/ad-types',
  path: '/ad-types',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaAdCategoriesRoute = AuthMediaAdCategoriesRouteImport.update({
  id: '/ad-categories',
  path: '/ad-categories',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthClientsClientIdRoute = AuthClientsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => AuthClientsRoute,
} as any)
const AuthAdminUsersRoute = AuthAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminProjectsRoute = AuthAdminProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminOutletKindsRoute = AuthAdminOutletKindsRouteImport.update({
  id: '/outlet-kinds',
  path: '/outlet-kinds',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminLoginContentRoute = AuthAdminLoginContentRouteImport.update({
  id: '/login-content',
  path: '/login-content',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminBrandingRoute = AuthAdminBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminBillingRoute = AuthAdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminAuditRoute = AuthAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthMonitorProjectIdSetupRoute =
  AuthMonitorProjectIdSetupRouteImport.update({
    id: '/monitor/$projectId_/setup',
    path: '/monitor/$projectId/setup',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMediaReportsReportIdRoute =
  AuthMediaReportsReportIdRouteImport.update({
    id: '/reports_/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AuthMediaRoute,
  } as any)
const AuthMediaPlacementsPlacementIdRoute =
  AuthMediaPlacementsPlacementIdRouteImport.update({
    id: '/placements_/$placementId',
    path: '/placements/$placementId',
    getParentRoute: () => AuthMediaRoute,
  } as any)
const AuthMediaCampaignsNewRoute = AuthMediaCampaignsNewRouteImport.update({
  id: '/campaigns_/new',
  path: '/campaigns/new',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthMediaCampaignsCampaignIdRoute =
  AuthMediaCampaignsCampaignIdRouteImport.update({
    id: '/campaigns_/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AuthMediaRoute,
  } as any)
const AuthMediaAdsAdIdRoute = AuthMediaAdsAdIdRouteImport.update({
  id: '/ads_/$adId',
  path: '/ads/$adId',
  getParentRoute: () => AuthMediaRoute,
} as any)
const AuthAdminAccountsAccountIdRoute =
  AuthAdminAccountsAccountIdRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthMediaReportsRunsRunIdRoute =
  AuthMediaReportsRunsRunIdRouteImport.update({
    id: '/reports_/runs/$runId',
    path: '/reports/runs/$runId',
    getParentRoute: () => AuthMediaRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/analyze': typeof AuthAnalyzeRoute
  '/clients': typeof AuthClientsRouteWithChildren
  '/dashboard': typeof AuthDashboardRoute
  '/media': typeof AuthMediaRouteWithChildren
  '/onboarding': typeof AuthOnboardingRoute
  '/responder': typeof AuthResponderRoute
  '/schedule': typeof AuthScheduleRoute
  '/settings': typeof AuthSettingsRoute
  '/r/$slug': typeof RSlugRoute
  '/admin/audit': typeof AuthAdminAuditRoute
  '/admin/billing': typeof AuthAdminBillingRoute
  '/admin/branding': typeof AuthAdminBrandingRoute
  '/admin/login-content': typeof AuthAdminLoginContentRoute
  '/admin/outlet-kinds': typeof AuthAdminOutletKindsRoute
  '/admin/projects': typeof AuthAdminProjectsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/clients/$clientId': typeof AuthClientsClientIdRoute
  '/media/ad-categories': typeof AuthMediaAdCategoriesRoute
  '/media/ad-types': typeof AuthMediaAdTypesRoute
  '/media/ads': typeof AuthMediaAdsRoute
  '/media/budgets': typeof AuthMediaBudgetsRoute
  '/media/campaigns': typeof AuthMediaCampaignsRoute
  '/media/clients': typeof AuthMediaClientsRoute
  '/media/outlets': typeof AuthMediaOutletsRoute
  '/media/reports': typeof AuthMediaReportsRoute
  '/monitor/$projectId': typeof AuthMonitorProjectIdRoute
  '/public/reports/$token': typeof PublicReportsTokenRoute
  '/admin/': typeof AuthAdminIndexRoute
  '/clients/': typeof AuthClientsIndexRoute
  '/media/': typeof AuthMediaIndexRoute
  '/monitor/': typeof AuthMonitorIndexRoute
  '/admin/accounts/$accountId': typeof AuthAdminAccountsAccountIdRoute
  '/media/ads/$adId': typeof AuthMediaAdsAdIdRoute
  '/media/campaigns/$campaignId': typeof AuthMediaCampaignsCampaignIdRoute
  '/media/campaigns/new': typeof AuthMediaCampaignsNewRoute
  '/media/placements/$placementId': typeof AuthMediaPlacementsPlacementIdRoute
  '/media/reports/$reportId': typeof AuthMediaReportsReportIdRoute
  '/monitor/$projectId/setup': typeof AuthMonitorProjectIdSetupRoute
  '/media/reports/runs/$runId': typeof AuthMediaReportsRunsRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analyze': typeof AuthAnalyzeRoute
  '/dashboard': typeof AuthDashboardRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/responder': typeof AuthResponderRoute
  '/schedule': typeof AuthScheduleRoute
  '/settings': typeof AuthSettingsRoute
  '/r/$slug': typeof RSlugRoute
  '/admin/audit': typeof AuthAdminAuditRoute
  '/admin/billing': typeof AuthAdminBillingRoute
  '/admin/branding': typeof AuthAdminBrandingRoute
  '/admin/login-content': typeof AuthAdminLoginContentRoute
  '/admin/outlet-kinds': typeof AuthAdminOutletKindsRoute
  '/admin/projects': typeof AuthAdminProjectsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/clients/$clientId': typeof AuthClientsClientIdRoute
  '/media/ad-categories': typeof AuthMediaAdCategoriesRoute
  '/media/ad-types': typeof AuthMediaAdTypesRoute
  '/media/ads': typeof AuthMediaAdsRoute
  '/media/budgets': typeof AuthMediaBudgetsRoute
  '/media/campaigns': typeof AuthMediaCampaignsRoute
  '/media/clients': typeof AuthMediaClientsRoute
  '/media/outlets': typeof AuthMediaOutletsRoute
  '/media/reports': typeof AuthMediaReportsRoute
  '/monitor/$projectId': typeof AuthMonitorProjectIdRoute
  '/public/reports/$token': typeof PublicReportsTokenRoute
  '/admin': typeof AuthAdminIndexRoute
  '/clients': typeof AuthClientsIndexRoute
  '/media': typeof AuthMediaIndexRoute
  '/monitor': typeof AuthMonitorIndexRoute
  '/admin/accounts/$accountId': typeof AuthAdminAccountsAccountIdRoute
  '/media/ads/$adId': typeof AuthMediaAdsAdIdRoute
  '/media/campaigns/$campaignId': typeof AuthMediaCampaignsCampaignIdRoute
  '/media/campaigns/new': typeof AuthMediaCampaignsNewRoute
  '/media/placements/$placementId': typeof AuthMediaPlacementsPlacementIdRoute
  '/media/reports/$reportId': typeof AuthMediaReportsReportIdRoute
  '/monitor/$projectId/setup': typeof AuthMonitorProjectIdSetupRoute
  '/media/reports/runs/$runId': typeof AuthMediaReportsRunsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/analyze': typeof AuthAnalyzeRoute
  '/_auth/clients': typeof AuthClientsRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/media': typeof AuthMediaRouteWithChildren
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/_auth/responder': typeof AuthResponderRoute
  '/_auth/schedule': typeof AuthScheduleRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/r/$slug': typeof RSlugRoute
  '/_auth/admin/audit': typeof AuthAdminAuditRoute
  '/_auth/admin/billing': typeof AuthAdminBillingRoute
  '/_auth/admin/branding': typeof AuthAdminBrandingRoute
  '/_auth/admin/login-content': typeof AuthAdminLoginContentRoute
  '/_auth/admin/outlet-kinds': typeof AuthAdminOutletKindsRoute
  '/_auth/admin/projects': typeof AuthAdminProjectsRoute
  '/_auth/admin/users': typeof AuthAdminUsersRoute
  '/_auth/clients/$clientId': typeof AuthClientsClientIdRoute
  '/_auth/media/ad-categories': typeof AuthMediaAdCategoriesRoute
  '/_auth/media/ad-types': typeof AuthMediaAdTypesRoute
  '/_auth/media/ads': typeof AuthMediaAdsRoute
  '/_auth/media/budgets': typeof AuthMediaBudgetsRoute
  '/_auth/media/campaigns': typeof AuthMediaCampaignsRoute
  '/_auth/media/clients': typeof AuthMediaClientsRoute
  '/_auth/media/outlets': typeof AuthMediaOutletsRoute
  '/_auth/media/reports': typeof AuthMediaReportsRoute
  '/_auth/monitor/$projectId': typeof AuthMonitorProjectIdRoute
  '/public/reports/$token': typeof PublicReportsTokenRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/clients/': typeof AuthClientsIndexRoute
  '/_auth/media/': typeof AuthMediaIndexRoute
  '/_auth/monitor/': typeof AuthMonitorIndexRoute
  '/_auth/admin/accounts/$accountId': typeof AuthAdminAccountsAccountIdRoute
  '/_auth/media/ads_/$adId': typeof AuthMediaAdsAdIdRoute
  '/_auth/media/campaigns_/$campaignId': typeof AuthMediaCampaignsCampaignIdRoute
  '/_auth/media/campaigns_/new': typeof AuthMediaCampaignsNewRoute
  '/_auth/media/placements_/$placementId': typeof AuthMediaPlacementsPlacementIdRoute
  '/_auth/media/reports_/$reportId': typeof AuthMediaReportsReportIdRoute
  '/_auth/monitor/$projectId_/setup': typeof AuthMonitorProjectIdSetupRoute
  '/_auth/media/reports_/runs/$runId': typeof AuthMediaReportsRunsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/analyze'
    | '/clients'
    | '/dashboard'
    | '/media'
    | '/onboarding'
    | '/responder'
    | '/schedule'
    | '/settings'
    | '/r/$slug'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/branding'
    | '/admin/login-content'
    | '/admin/outlet-kinds'
    | '/admin/projects'
    | '/admin/users'
    | '/clients/$clientId'
    | '/media/ad-categories'
    | '/media/ad-types'
    | '/media/ads'
    | '/media/budgets'
    | '/media/campaigns'
    | '/media/clients'
    | '/media/outlets'
    | '/media/reports'
    | '/monitor/$projectId'
    | '/public/reports/$token'
    | '/admin/'
    | '/clients/'
    | '/media/'
    | '/monitor/'
    | '/admin/accounts/$accountId'
    | '/media/ads/$adId'
    | '/media/campaigns/$campaignId'
    | '/media/campaigns/new'
    | '/media/placements/$placementId'
    | '/media/reports/$reportId'
    | '/monitor/$projectId/setup'
    | '/media/reports/runs/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/analyze'
    | '/dashboard'
    | '/onboarding'
    | '/responder'
    | '/schedule'
    | '/settings'
    | '/r/$slug'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/branding'
    | '/admin/login-content'
    | '/admin/outlet-kinds'
    | '/admin/projects'
    | '/admin/users'
    | '/clients/$clientId'
    | '/media/ad-categories'
    | '/media/ad-types'
    | '/media/ads'
    | '/media/budgets'
    | '/media/campaigns'
    | '/media/clients'
    | '/media/outlets'
    | '/media/reports'
    | '/monitor/$projectId'
    | '/public/reports/$token'
    | '/admin'
    | '/clients'
    | '/media'
    | '/monitor'
    | '/admin/accounts/$accountId'
    | '/media/ads/$adId'
    | '/media/campaigns/$campaignId'
    | '/media/campaigns/new'
    | '/media/placements/$placementId'
    | '/media/reports/$reportId'
    | '/monitor/$projectId/setup'
    | '/media/reports/runs/$runId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/admin'
    | '/_auth/analyze'
    | '/_auth/clients'
    | '/_auth/dashboard'
    | '/_auth/media'
    | '/_auth/onboarding'
    | '/_auth/responder'
    | '/_auth/schedule'
    | '/_auth/settings'
    | '/r/$slug'
    | '/_auth/admin/audit'
    | '/_auth/admin/billing'
    | '/_auth/admin/branding'
    | '/_auth/admin/login-content'
    | '/_auth/admin/outlet-kinds'
    | '/_auth/admin/projects'
    | '/_auth/admin/users'
    | '/_auth/clients/$clientId'
    | '/_auth/media/ad-categories'
    | '/_auth/media/ad-types'
    | '/_auth/media/ads'
    | '/_auth/media/budgets'
    | '/_auth/media/campaigns'
    | '/_auth/media/clients'
    | '/_auth/media/outlets'
    | '/_auth/media/reports'
    | '/_auth/monitor/$projectId'
    | '/public/reports/$token'
    | '/_auth/admin/'
    | '/_auth/clients/'
    | '/_auth/media/'
    | '/_auth/monitor/'
    | '/_auth/admin/accounts/$accountId'
    | '/_auth/media/ads_/$adId'
    | '/_auth/media/campaigns_/$campaignId'
    | '/_auth/media/campaigns_/new'
    | '/_auth/media/placements_/$placementId'
    | '/_auth/media/reports_/$reportId'
    | '/_auth/monitor/$projectId_/setup'
    | '/_auth/media/reports_/runs/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  RSlugRoute: typeof RSlugRoute
  PublicReportsTokenRoute: typeof PublicReportsTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$slug': {
      id: '/r/$slug'
      path: '/r/$slug'
      fullPath: '/r/$slug'
      preLoaderRoute: typeof RSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schedule': {
      id: '/_auth/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthScheduleRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/responder': {
      id: '/_auth/responder'
      path: '/responder'
      fullPath: '/responder'
      preLoaderRoute: typeof AuthResponderRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/media': {
      id: '/_auth/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof AuthMediaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients': {
      id: '/_auth/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthClientsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/analyze': {
      id: '/_auth/analyze'
      path: '/analyze'
      fullPath: '/analyze'
      preLoaderRoute: typeof AuthAnalyzeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/monitor/': {
      id: '/_auth/monitor/'
      path: '/monitor'
      fullPath: '/monitor/'
      preLoaderRoute: typeof AuthMonitorIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/media/': {
      id: '/_auth/media/'
      path: '/'
      fullPath: '/media/'
      preLoaderRoute: typeof AuthMediaIndexRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/clients/': {
      id: '/_auth/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthClientsIndexRouteImport
      parentRoute: typeof AuthClientsRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/public/reports/$token': {
      id: '/public/reports/$token'
      path: '/public/reports/$token'
      fullPath: '/public/reports/$token'
      preLoaderRoute: typeof PublicReportsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/monitor/$projectId': {
      id: '/_auth/monitor/$projectId'
      path: '/monitor/$projectId'
      fullPath: '/monitor/$projectId'
      preLoaderRoute: typeof AuthMonitorProjectIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/media/reports': {
      id: '/_auth/media/reports'
      path: '/reports'
      fullPath: '/media/reports'
      preLoaderRoute: typeof AuthMediaReportsRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/outlets': {
      id: '/_auth/media/outlets'
      path: '/outlets'
      fullPath: '/media/outlets'
      preLoaderRoute: typeof AuthMediaOutletsRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/clients': {
      id: '/_auth/media/clients'
      path: '/clients'
      fullPath: '/media/clients'
      preLoaderRoute: typeof AuthMediaClientsRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/campaigns': {
      id: '/_auth/media/campaigns'
      path: '/campaigns'
      fullPath: '/media/campaigns'
      preLoaderRoute: typeof AuthMediaCampaignsRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/budgets': {
      id: '/_auth/media/budgets'
      path: '/budgets'
      fullPath: '/media/budgets'
      preLoaderRoute: typeof AuthMediaBudgetsRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/ads': {
      id: '/_auth/media/ads'
      path: '/ads'
      fullPath: '/media/ads'
      preLoaderRoute: typeof AuthMediaAdsRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/ad-types': {
      id: '/_auth/media/ad-types'
      path: '/ad-types'
      fullPath: '/media/ad-types'
      preLoaderRoute: typeof AuthMediaAdTypesRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/ad-categories': {
      id: '/_auth/media/ad-categories'
      path: '/ad-categories'
      fullPath: '/media/ad-categories'
      preLoaderRoute: typeof AuthMediaAdCategoriesRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/clients/$clientId': {
      id: '/_auth/clients/$clientId'
      path: '/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthClientsClientIdRouteImport
      parentRoute: typeof AuthClientsRoute
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/projects': {
      id: '/_auth/admin/projects'
      path: '/projects'
      fullPath: '/admin/projects'
      preLoaderRoute: typeof AuthAdminProjectsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/outlet-kinds': {
      id: '/_auth/admin/outlet-kinds'
      path: '/outlet-kinds'
      fullPath: '/admin/outlet-kinds'
      preLoaderRoute: typeof AuthAdminOutletKindsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/login-content': {
      id: '/_auth/admin/login-content'
      path: '/login-content'
      fullPath: '/admin/login-content'
      preLoaderRoute: typeof AuthAdminLoginContentRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/branding': {
      id: '/_auth/admin/branding'
      path: '/branding'
      fullPath: '/admin/branding'
      preLoaderRoute: typeof AuthAdminBrandingRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/billing': {
      id: '/_auth/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AuthAdminBillingRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/audit': {
      id: '/_auth/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AuthAdminAuditRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/monitor/$projectId_/setup': {
      id: '/_auth/monitor/$projectId_/setup'
      path: '/monitor/$projectId/setup'
      fullPath: '/monitor/$projectId/setup'
      preLoaderRoute: typeof AuthMonitorProjectIdSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/media/reports_/$reportId': {
      id: '/_auth/media/reports_/$reportId'
      path: '/reports/$reportId'
      fullPath: '/media/reports/$reportId'
      preLoaderRoute: typeof AuthMediaReportsReportIdRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/placements_/$placementId': {
      id: '/_auth/media/placements_/$placementId'
      path: '/placements/$placementId'
      fullPath: '/media/placements/$placementId'
      preLoaderRoute: typeof AuthMediaPlacementsPlacementIdRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/campaigns_/new': {
      id: '/_auth/media/campaigns_/new'
      path: '/campaigns/new'
      fullPath: '/media/campaigns/new'
      preLoaderRoute: typeof AuthMediaCampaignsNewRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/campaigns_/$campaignId': {
      id: '/_auth/media/campaigns_/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/media/campaigns/$campaignId'
      preLoaderRoute: typeof AuthMediaCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/media/ads_/$adId': {
      id: '/_auth/media/ads_/$adId'
      path: '/ads/$adId'
      fullPath: '/media/ads/$adId'
      preLoaderRoute: typeof AuthMediaAdsAdIdRouteImport
      parentRoute: typeof AuthMediaRoute
    }
    '/_auth/admin/accounts/$accountId': {
      id: '/_auth/admin/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/admin/accounts/$accountId'
      preLoaderRoute: typeof AuthAdminAccountsAccountIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/media/reports_/runs/$runId': {
      id: '/_auth/media/reports_/runs/$runId'
      path: '/reports/runs/$runId'
      fullPath: '/media/reports/runs/$runId'
      preLoaderRoute: typeof AuthMediaReportsRunsRunIdRouteImport
      parentRoute: typeof AuthMediaRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminAuditRoute: typeof AuthAdminAuditRoute
  AuthAdminBillingRoute: typeof AuthAdminBillingRoute
  AuthAdminBrandingRoute: typeof AuthAdminBrandingRoute
  AuthAdminLoginContentRoute: typeof AuthAdminLoginContentRoute
  AuthAdminOutletKindsRoute: typeof AuthAdminOutletKindsRoute
  AuthAdminProjectsRoute: typeof AuthAdminProjectsRoute
  AuthAdminUsersRoute: typeof AuthAdminUsersRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
  AuthAdminAccountsAccountIdRoute: typeof AuthAdminAccountsAccountIdRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminAuditRoute: AuthAdminAuditRoute,
  AuthAdminBillingRoute: AuthAdminBillingRoute,
  AuthAdminBrandingRoute: AuthAdminBrandingRoute,
  AuthAdminLoginContentRoute: AuthAdminLoginContentRoute,
  AuthAdminOutletKindsRoute: AuthAdminOutletKindsRoute,
  AuthAdminProjectsRoute: AuthAdminProjectsRoute,
  AuthAdminUsersRoute: AuthAdminUsersRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
  AuthAdminAccountsAccountIdRoute: AuthAdminAccountsAccountIdRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthClientsRouteChildren {
  AuthClientsClientIdRoute: typeof AuthClientsClientIdRoute
  AuthClientsIndexRoute: typeof AuthClientsIndexRoute
}

const AuthClientsRouteChildren: AuthClientsRouteChildren = {
  AuthClientsClientIdRoute: AuthClientsClientIdRoute,
  AuthClientsIndexRoute: AuthClientsIndexRoute,
}

const AuthClientsRouteWithChildren = AuthClientsRoute._addFileChildren(
  AuthClientsRouteChildren,
)

interface AuthMediaRouteChildren {
  AuthMediaAdCategoriesRoute: typeof AuthMediaAdCategoriesRoute
  AuthMediaAdTypesRoute: typeof AuthMediaAdTypesRoute
  AuthMediaAdsRoute: typeof AuthMediaAdsRoute
  AuthMediaBudgetsRoute: typeof AuthMediaBudgetsRoute
  AuthMediaCampaignsRoute: typeof AuthMediaCampaignsRoute
  AuthMediaClientsRoute: typeof AuthMediaClientsRoute
  AuthMediaOutletsRoute: typeof AuthMediaOutletsRoute
  AuthMediaReportsRoute: typeof AuthMediaReportsRoute
  AuthMediaIndexRoute: typeof AuthMediaIndexRoute
  AuthMediaAdsAdIdRoute: typeof AuthMediaAdsAdIdRoute
  AuthMediaCampaignsCampaignIdRoute: typeof AuthMediaCampaignsCampaignIdRoute
  AuthMediaCampaignsNewRoute: typeof AuthMediaCampaignsNewRoute
  AuthMediaPlacementsPlacementIdRoute: typeof AuthMediaPlacementsPlacementIdRoute
  AuthMediaReportsReportIdRoute: typeof AuthMediaReportsReportIdRoute
  AuthMediaReportsRunsRunIdRoute: typeof AuthMediaReportsRunsRunIdRoute
}

const AuthMediaRouteChildren: AuthMediaRouteChildren = {
  AuthMediaAdCategoriesRoute: AuthMediaAdCategoriesRoute,
  AuthMediaAdTypesRoute: AuthMediaAdTypesRoute,
  AuthMediaAdsRoute: AuthMediaAdsRoute,
  AuthMediaBudgetsRoute: AuthMediaBudgetsRoute,
  AuthMediaCampaignsRoute: AuthMediaCampaignsRoute,
  AuthMediaClientsRoute: AuthMediaClientsRoute,
  AuthMediaOutletsRoute: AuthMediaOutletsRoute,
  AuthMediaReportsRoute: AuthMediaReportsRoute,
  AuthMediaIndexRoute: AuthMediaIndexRoute,
  AuthMediaAdsAdIdRoute: AuthMediaAdsAdIdRoute,
  AuthMediaCampaignsCampaignIdRoute: AuthMediaCampaignsCampaignIdRoute,
  AuthMediaCampaignsNewRoute: AuthMediaCampaignsNewRoute,
  AuthMediaPlacementsPlacementIdRoute: AuthMediaPlacementsPlacementIdRoute,
  AuthMediaReportsReportIdRoute: AuthMediaReportsReportIdRoute,
  AuthMediaReportsRunsRunIdRoute: AuthMediaReportsRunsRunIdRoute,
}

const AuthMediaRouteWithChildren = AuthMediaRoute._addFileChildren(
  AuthMediaRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthAnalyzeRoute: typeof AuthAnalyzeRoute
  AuthClientsRoute: typeof AuthClientsRouteWithChildren
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthMediaRoute: typeof AuthMediaRouteWithChildren
  AuthOnboardingRoute: typeof AuthOnboardingRoute
  AuthResponderRoute: typeof AuthResponderRoute
  AuthScheduleRoute: typeof AuthScheduleRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthMonitorProjectIdRoute: typeof AuthMonitorProjectIdRoute
  AuthMonitorIndexRoute: typeof AuthMonitorIndexRoute
  AuthMonitorProjectIdSetupRoute: typeof AuthMonitorProjectIdSetupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthAnalyzeRoute: AuthAnalyzeRoute,
  AuthClientsRoute: AuthClientsRouteWithChildren,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthMediaRoute: AuthMediaRouteWithChildren,
  AuthOnboardingRoute: AuthOnboardingRoute,
  AuthResponderRoute: AuthResponderRoute,
  AuthScheduleRoute: AuthScheduleRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthMonitorProjectIdRoute: AuthMonitorProjectIdRoute,
  AuthMonitorIndexRoute: AuthMonitorIndexRoute,
  AuthMonitorProjectIdSetupRoute: AuthMonitorProjectIdSetupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  RSlugRoute: RSlugRoute,
  PublicReportsTokenRoute: PublicReportsTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
